const colors: Record<string, string> = {
    primary: '#1b1a20',
    secondary: '#eabf00',
    clay_blue: '#467fdb',
    clay_blue_dark: '#2566cf',
    white: '#ffffff',
    grey_white: '#fcfcfc',
    floralwhite: 'floralwhite',
    border_grey: '#f0f0f0',
    cadetblue: 'cadetblue',
    burlywood: 'burlywood',
    dark_grey: '#454545',
    grey: 'grey',
    black: 'black',
    warning_red: '#db3737',
    green_blue: '#1cb2b8',
    green_blue_dark: '#179499',
    love_red: '#FF4081',
};

const breakpoints: Record<string, string> = {
    mobile: '480px',
    tablet: '768px',
    desktop: '1025px',
    largeDesktop: '1200px',
};

const theme = {
    colors,
    breakpoints,
};

export default theme;
